import { BehaviorSubject } from "rxjs";

import { type APIUserResponse } from "@/data_source/models/APIUserResponse";

import { Store } from "./store";

export class UserStore extends Store<APIUserResponse> {
  protected _observable: BehaviorSubject<APIUserResponse | null>;
  private static instance?: UserStore;
  private constructor() {
    super();
    this._observable = new BehaviorSubject<APIUserResponse | null>(null);
  }
  static getInstance(): UserStore {
    UserStore.instance = UserStore.instance ?? new UserStore();
    return UserStore.instance;
  }
}
